import React from 'react';
import { useHomeSectionHashRedirect } from '@hooks/useHomeSectionHashScroll';

/**
 * Redirects homepage section hashes to / when opened from another route.
 */
export const HomeSectionHashHandler: React.FC = () => {
  useHomeSectionHashRedirect();
  return null;
};

export default HomeSectionHashHandler;
